/**
 * Added endTimestamp restriction to FB query based on todays date
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {object} filters
 * @returns {object} params
 */

const composeRuntimeEvent = (filters = {}) => {
  let params = {};
  const today = new Date();
  params['ge_endTimestamp'] = '';
  if (filters?.ge_endTimestamp?.toString() === 'true' || !filters.ge_endTimestamp)
    params['ge_endTimestamp'] = today.getFullYear().toString() + (today.getMonth() + 1).toString().padStart(2, '0') + today.getDate().toString().padStart(2, '0');
  return params;
};

export default composeRuntimeEvent;
